const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isEmpty = (value) => {
  return value === null || value === undefined || value.trim() === "";
};

export const isValidEmail = (email) => {
  return !isEmpty(email) ? regexEmail.test(email) : false;
};
